import {
  EditProfileRoleDepartmentResponse,
  FinishOnboardingStepResponse,
} from '@otter-ai/recall-client';

export const NEW_ONBOARDING_FLOW = {
  GENERAL_EMAIL: 'EmailSignUpFlow',
  GENERAL_THIRD_PARTY: 'ThirdPartySignupFlow',
  WORKSPACE_MEMBER: 'WorkspaceMemberFlow',
  WORKSPACE_ADMIN: 'WorkspaceAdminFlow',
  POST_CALENDAR_CONNECTION: 'PostCalendarConnectionFlow',
  SHARED_SPEECH_EMAIL_SIGNUP: 'SharedSpeechEmailSignupFlow',
  SHARED_SPEECH_THIRD_PARTY_SIGNUP: 'SharedSpeechThirdPartySignupFlow',
  SLACK_SIGNUP: 'SlackSignupFlow',
  WORKSPACE_REVERSE_TRIAL_INFO_FLOW: 'WorkspaceReverseTrialInfoFlow',
  PAID_MEDIA: 'PaidMediaSignUpFlow',
  PRO_POST_PURCHASE: 'ProPostPurchaseFlow',
  BIZ_POST_PURCHASE: 'BizPostPurchaseFlow',
  POST_PURCHASE_V2: 'PostPurchaseV2Flow',
} as const;
export type NEW_ONBOARDING_FLOW =
  (typeof NEW_ONBOARDING_FLOW)[keyof typeof NEW_ONBOARDING_FLOW];

export const NEW_ONBOARDING_STEP = {
  verify_email: 'verify_email',
  otter_assistant_questionnaire: 'otter_assistant_questionnaire',
  otter_assistant_fallback: 'otter_assistant_fallback',
  otter_assistant_questionnaire_retry: 'otter_assistant_questionnaire_retry',
  otter_assistant_fallback_retry: 'otter_assistant_fallback_retry',
  join_workspace: 'join_workspace',
  invite_suggested_teammate: 'invite_suggested_teammate',
  connect_zoom: 'connect_zoom',
  workspace_discoverability: 'workspace_discoverability',
  invite_teammate: 'invite_teammate',
  basic_workspace_info: 'basic_workspace_info',
  basic_workspace_invite_teammates: 'basic_workspace_invite_teammates',
  end_step: 'EndStep',
  workspace_reverse_trial_info: 'workspace_reverse_trial_info',
  credit_card_purchase: 'credit_card_purchase',
  credit_card_trial_info: 'credit_card_trial_info',
  credit_card_trial_plan_selection: 'credit_card_trial_plan_selection',
  credit_card_trial_payment: 'credit_card_trial_payment',
  department_and_role_selector: 'department_and_role_selector',
  contact_sales: 'contact_sales',
  basic_workspace_referral: 'basic_workspace_referral',
  annual_plan_switch: 'annual_plan_switch',
  promote_apps: 'promote_apps',
  post_purchase_workspace_info: 'post_purchase_workspace_info',
  post_purchase_invite_teammate: 'post_purchase_invite_teammate',
} as const;
export type NEW_ONBOARDING_STEP =
  (typeof NEW_ONBOARDING_STEP)[keyof typeof NEW_ONBOARDING_STEP];

export type FinishOnboardingStepType = FinishOnboardingStepResponse;

export type EditProfileRoleDepartmentType = EditProfileRoleDepartmentResponse;
